import { render, staticRenderFns } from "./CalendarTimezoneSwitcher.vue?vue&type=template&id=cd795c02"
import script from "./CalendarTimezoneSwitcher.vue?vue&type=script&lang=js"
export * from "./CalendarTimezoneSwitcher.vue?vue&type=script&lang=js"
import style0 from "./CalendarTimezoneSwitcher.vue?vue&type=style&index=0&id=cd795c02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports